var _ = require('underscore');

var TorsoBehavior = require('backbone-torso/modules/Behavior');

/**
 * This behavior recalculates the class name on every render and updates it in post render.
 * It will read the class name from the view state to make the interaction and updates easier.
 *
 * The view's configured className property is used as the default value for the class name and is updated
 * when the className changes.
 *
 * setClassName({String}) is exposed on the view to conveniently set the class name.
 *
 * @class DynamicClassNameBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({
  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    var view = this.view;
    this.set('className', _.result(view, 'className'));
    this.on('change:className', _.bind(view.render, view));
  },

  mixin: {
    /**
     * Expose a method on the view that can be used to set the class name dynamically.
     * This will also update the className property on the view for consistency.
     * @method mixin.setClassName
     * @param newClassName {String} the new className to use for this view.
     */
    setClassName: function(newClassName) {
      this.set('className', newClassName);
      this.view.className = newClassName;
    }
  },

  /**
   * @method postrender
   * @override
   */
  postrender: function() {
    var newClassName = this.get('className');
    this.view.$el.attr('class', newClassName);
  }
});
